import React, { useEffect, memo, createContext } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import MessageList from "./messageList";
import MessageBar from "./messageBar/index";
import { useSelector } from "../../EaseApp/index";
import { Provider } from "react-redux";
import SendBox from "./sendBox";
import WebIM, { initIMSDK } from "../../utils/WebIM";
import store from "../../redux/index";
import createlistener from "../../utils/WebIMListen";
import _ from "lodash";
import "../../i18n";
import "../../common/iconfont.css";
import noMessage from "../../common/images/nomessage.png";
import i18next from "i18next";
export var EaseChatContext = createContext();
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      height: "calc(100% - 20px)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative"
    }
  };
});

var Chat = function Chat(props) {
  useEffect(function () {
    if (props.appkey && props.username && props.agoraToken) {
      initIMSDK(props.appkey);
      createlistener(props);

      if (WebIM.conn.logOut) {
        login();
      }
    }
  }, []);

  var login = function login() {
    var noLogin = WebIM.conn.logOut;
    noLogin && WebIM.conn.open({
      user: props.username,
      agoraToken: props.agoraToken,
      appKey: WebIM.config.appkey
    });
  };

  var classes = useStyles();
  var messageList = useSelector(function (state) {
    var to = state.global.globalProps.to;
    var chatType = state.global.globalProps.chatType;
    return _.get(state, ["message", chatType, to], []);
  }) || [];
  var to = useSelector(function (state) {
    return state.global.globalProps.to;
  });
  return to ? /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(EaseChatContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(MessageBar, null), /*#__PURE__*/React.createElement(MessageList, {
    messageList: messageList,
    showByselfAvatar: props.showByselfAvatar
  }), /*#__PURE__*/React.createElement(SendBox, null))) : /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: noMessage,
    alt: "",
    style: {
      height: "200px",
      width: "200px"
    }
  }));
};

var EaseChatProvider = function EaseChatProvider(props) {
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(Chat, props)));
};

EaseChatProvider.getSdk = function (props) {
  if (!WebIM.conn) {
    initIMSDK(props.appkey);
    createlistener(props);
  }

  return WebIM;
};

export default EaseChatProvider;
EaseChatProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  appkey: PropTypes.string,
  username: PropTypes.string,
  agoraToken: PropTypes.string,
  chatType: PropTypes.string,
  to: PropTypes.string,
  showByselfAvatar: PropTypes.bool,
  easeInputMenu: PropTypes.string,
  menuList: PropTypes.array,
  handleMenuItem: PropTypes.func,
  successLoginCallback: PropTypes.func,
  failCallback: PropTypes.func
} : {};
EaseChatProvider.defaultProps = {
  showByselfAvatar: false,
  easeInputMenu: 'all',
  menuList: [{
    name: i18next.t('send-image'),
    value: "img",
    key: "1"
  }, {
    name: i18next.t('send-file'),
    value: "file",
    key: "2"
  }]
};